import { useSelector, useDispatch } from "react-redux"

import { selectMessages, emptyMessages, dismissMessage } from "src/store/messages"

import "./MessageHandler.css"
import { useEffect } from "react"

const MessageHandler = () => {
  // Message types: info, success, warning, error
  const dispatch = useDispatch()
  const messages = useSelector(selectMessages)

  useEffect(() => {
    if (messages.length === 0) return

    const event = setTimeout(() => {
      dispatch(emptyMessages())
    }, 5000)
    return () => clearTimeout(event)
  }, [dispatch, messages])

  return (
    <div className="message-container">
      {messages.map((message) => (
        <div key={message.id} className={`message ${message.type}`} onClick={() => dispatch(dismissMessage(message.id))}>
          {message.text}
        </div>
      ))}
    </div>
  )
}

export default MessageHandler
